import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  homePageData: null,
  packageFilterData: null,
  patients: null,
  cityList: null,
  bookingStatus: null,
  packagePageBanner: null,
  testPageBanner: null,
  cartData: null,
};

export const APIsDataSlice = createSlice({
  name: "APIsDataSlice",
  initialState,

  reducers: {
    setHomePageData: (state, action) => {
      state.homePageData = action.payload;
    },
    setPackageFilterData: (state, action) => {
      state.packageFilterData = action.payload;
    },
    setPatientsData: (state, action) => {
      state.patients = action.payload;
    },
    setBookingStatus: (state, action) => {
      state.bookingStatus = action.payload;
    },
    setCityList: (state, action) => {
      state.cityList = action.payload;
    },
    setPakagePageBanner: (state, action) => {
      state.packagePageBanner = action.payload;
    },
    setTestPageBanner: (state, action) => {
      state.testPageBanner = action.payload;
    },
  },
});

export const {
  setHomePageData,
  setPackageFilterData,
  setPatientsData,
  setBookingStatus,
  setCityList,
  setPakagePageBanner,
  setTestPageBanner,
} = APIsDataSlice.actions;
export default APIsDataSlice.reducer;
